
  import { integrationsService } from '@/services/integrations/integrationsService';
  import { ActivatedIntegration, IntegrationDetailed } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { pushRoute } from '@/ui/helpers';
  import { defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      ConfirmationModal,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const integration = store.integration as IntegrationDetailed;
      const hasNewVersion = integrationsService.isActivated(integration) && integrationsService.hasNewVersion(integration);
      const isModalOpen = ref(false);
      const loading = ref(false);

      const showConfirmation = () => {
        isModalOpen.value = true;
      };

      const hideConfirmation = () => {
        isModalOpen.value = false;
      };

      const upgradeIntegration = async () => {
        loading.value = true;
        const newIntegrationId = await integrationsService.upgradeInstance(integration as ActivatedIntegration & IntegrationDetailed);
        hideConfirmation();
        pushRoute({ name: 'integrationDetails', params: { id: newIntegrationId } });
      };

      return {
        hasNewVersion,
        showConfirmation,
        hideConfirmation,
        isModalOpen,
        upgradeIntegration,
        loading,
      };
    },
  });
